import React from "react";
import { Col } from "react-bootstrap";
import github from "../assets/img/github.svg";

export const ProjectCards = ({ title, description, imgUrl, githubUrl }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <div className="position-absolute top-0 end-0 m-2">
          <div className="social-icon">
            <a href= {githubUrl} target="_blank">
              <img src={github} alt="github" />
            </a>
          </div>
        </div>
        <img src={imgUrl} alt="" />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
      </div>
    </Col>
  );
};
